import { render, staticRenderFns } from "./PointViewer.vue?vue&type=template&id=3745557e&"
import script from "./PointViewer.vue?vue&type=script&lang=js&"
export * from "./PointViewer.vue?vue&type=script&lang=js&"
import style0 from "./PointViewer.vue?vue&type=style&index=0&id=3745557e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports